import { offlineDb } from './db';

/* Une conceptos del servidor con los guardados localmente (pendientes de sincronizar) */
export const mergeLocalConcepts = async (projectId, serverConcepts) => {
  try {
    const local = await offlineDb.getConceptsForProject(projectId);
    const known = new Set(serverConcepts.map((c) => c.id));
    const pending = local
      .filter((r) => !known.has(r.id))
      .map((r) => ({
        ...r.payload,
        importe: (r.payload.contratado || 0) * (r.payload.precio_unitario || 0),
        local: true,
      }));
    return [...serverConcepts, ...pending];
  } catch (e) {
    console.error('Offline: error leyendo conceptos locales', e);
    return serverConcepts;
  }
};
